<div class="box">
  @if (ribbonEnv) {
  <div class="ribbon ribbon-top-left">
    <span>{{ ribbonEnv }}</span>
  </div>
  }
</div>
